<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>1号AI > <b>数字人管理</b></BreadcrumbItem>
      </Breadcrumb>
	  <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
		  <span class="search_span_width">
		    <span class="search_span_width_part1">人物ID：</span>
		  				 <Input v-model="search.figure_id" clearable style="width: 80px" />
		  	</span>
	       <span class="search_span_width">
	         <span class="search_span_width_part1">数字人名称：</span>
	       				 <Input v-model="search.name" style="width: 130px" />
	       	</span>
	       <span class="search_span_width">
	         <span class="search_span_width_part1">渠道：</span>
				<Select v-model="search.channel" clearable style="width:150px">
					<Option v-for="item in channel_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
				</Select>
	       	</span>
	         <span class="search_span_width">
             <span class="search_span_width_part1">上架状态：</span>
              <Select v-model="search.status" clearable  style="width:130px">
                   <Option :value='-2'>未上架</Option>
                   <Option :value='-1'>待上架</Option>
                   <Option :value='1'>已上架</Option>
                   <Option :value='2'>已下架</Option>
              </Select>
	         </span>
	         <span class="search_span_width">
	             <span class="search_span_width_part1">上架位置：</span>
					<Select v-model="search.fit_type" clearable  style="width:130px">
						   <Option :value='1'>视频共享</Option>
						   <Option :value='2'>直播共享</Option>
						   <Option :value='3'>客户独享</Option>
						   <Option :value='4'>数字人商城</Option>
					</Select>
	         </span>
	    <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getFigureList(1)">搜索</Button>
	  </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="figure_list"></Table>
		   <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getFigureList"/>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="角色编辑">
        <Form ref="figure" :model="figure" :label-width="80" >
          <FormItem label="名称" prop="title">
             <Input v-model="figure.title"  :disabled='true'/>
          </FormItem>
          <FormItem label="人物设定" prop="persona">
            <Input v-model="figure.persona"  type="textarea" />
          </FormItem>
          <FormItem label="人设特定调优" prop="prompt">
            <Input v-model="figure.prompt"  type="textarea" />
          </FormItem>
          <FormItem label="标签" prop="user_label">
            <Input v-model="figure.user_label"  type="textarea" />
          </FormItem>
          <FormItem label="话题标签" prop="topic_label">
            <Input v-model="figure.topic_label"  type="textarea" />
            <dev style ="color: red">","英文逗号分割</dev>
          </FormItem>
          <FormItem label="简介" prop="introduction">
            <Input v-model="figure.introduction" type="textarea"  />
          </FormItem>
          <FormItem label="创建人简介" prop="create_user_introduction">
            <Input v-model="figure.create_user_introduction" type="textarea"  />
          </FormItem>
          <FormItem>
              <Button type="primary" @click="updateUserRole()">提交</Button>
          </FormItem>
        </Form>
    </Modal>
  </Layout>
</template>
<script>
import OSS from 'ali-oss';

export default {
  data(){
    return {
		search : {
			figure_id:'',
			channel:'',
			fit_type:0,
			status:0
		},
		loading2: false,
		showmodal:false,
		showshelfmodal:false,
		showtrainmodal:false,
		recordTotal:0,
		page:1,
		figure_list:[],
		user_list:[],
		channel_list:[],
		train:{
			id:0,
			video:'',
			train_video:'',
			figure_id:0,
			train_name:'',
			authorization_file:'',
			webm:''
		},
		figure:{
			id:0,
			title:'',
      user_label:'',
      introduction:'',
      create_user_introduction:'',
      topic_label:'',
      persona:'',
      prompt:'',
		},
		fit_type_user:false,
		shelfs:{
			id:0,
			channel:[],
			sex:'女',
			fit_type:[],
			user_id:[],
			seq:0
		},
		tableColumns:[
		{ title: '人物ID', key: 'id', align: 'center' },
		{ title: '名称', key: 'title', align: 'center' },
		{ title: '备注', key: 'name', align: 'center' },
		{ title: '头像', key: 'cover', align: 'center',
		render:(h,params) =>{
		   return h('img',{
			 attrs : {src : params.row.cover},
			 style : { width : '80px', height : '80px' }
		   })
		}},
		{ title: '模型状态', key: 'train_status', align: 'center' },
		{ title: '渠道', key: 'channel', align: 'center' },
		{ title: '操作', key: 'action', align: 'center',width: 200,
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {
						this.figure.title = params.row.title;
						this.figure.id = params.row.id;
            this.figure.persona = params.row.persona;
            this.figure.prompt = params.row.prompt;
            this.figure.user_label =params.row.user_label;
            this.figure.topic_label =params.row.topic_label;
            this.figure.introduction =params.row.introduction;
            this.figure.create_user_introduction =params.row.create_user_introduction;
					
						this.showmodal = true;
					}
				  }
				}, '角色编辑'),
			);
			return h("div",btns);
		  }
		}
		],
		uploadHeader:{
		  "Authorization":localStorage.getItem('token')
		},
	}
  },
  mounted:function(){
	this.getFigureList();
  },
  computed:{
	  getUploadUrl(){
	      return process.env.VUE_APP_APIHOST+'/admin/figure/upload';
	  }
  },
  methods:{
	changeFitType(e){
		//console.log(e);
		if (e.indexOf(3) != -1) {
			this.fit_type_user = true;
		} else {
			this.fit_type_user = false;
		}
	},

	getChannel() {
		this.http.get('/admin/common/settingKey',{params:{'key':'app_channel'}}).then(response=>{
		  let data=response.data;
		  console.log(data);
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.channel_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getFigureList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/figure/list',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.figure_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
    updateUserRole(){
		this.http.post('/admin/figure/updateUserRole',this.figure).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    this.showmodal = false;
			this.getFigureList(this.page);
		    return true;
		  }
		});
	},
	userlist(query){
		if (query !== '' && query.length==11) {
			this.loading2 = true;
			setTimeout(() => {
				this.loading2 = false;
				
				this.http.get('/admin/user/userList',{params:{mobile:query}}).then(response=>{
				  let data=response.data;
				  if(data.code!==0)
				  {
					alert(data.message);
				  } else{
					this.user_list = data.data.list;
				  }
				}).catch(()=>{
				  this.$Message.error('网络错误');
				});
				
			}, 200);
		}
	},
  }

}
</script>